var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49 0C8.6485 0 0 8.6485 0 49C0 89.3515 8.6485 98 49 98C89.3515 98 98 89.3515 98 49C98 8.6485 89.3515 0 49 0ZM49 10C16.8835 10 10 16.8835 10 49C10 81.1165 16.8835 88 49 88C81.1165 88 88 81.1165 88 49C88 16.8835 81.1165 10 49 10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 49C1 38.9349 1.54061 30.9151 2.958 24.5374C4.37287 18.1711 6.64806 13.5025 10.0753 10.0753C13.5025 6.64806 18.1711 4.37287 24.5374 2.958C30.9151 1.54061 38.9349 1 49 1C59.0651 1 67.0849 1.54061 73.4626 2.958C79.8289 4.37287 84.4975 6.64806 87.9247 10.0753C91.3519 13.5025 93.6271 18.1711 95.042 24.5374C96.4594 30.9151 97 38.9349 97 49C97 59.0651 96.4594 67.0849 95.042 73.4626C93.6271 79.8289 91.3519 84.4975 87.9247 87.9247C84.4975 91.3519 79.8289 93.6271 73.4626 95.042C67.0849 96.4594 59.0651 97 49 97C38.9349 97 30.9151 96.4594 24.5374 95.042C18.1711 93.6271 13.5025 91.3519 10.0753 87.9247C6.64806 84.4975 4.37287 79.8289 2.958 73.4626C1.54061 67.0849 1 59.0651 1 49Z",
    stroke: "#DEDEDE",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.e3f6213414d4eab344afcc399b12f648.svg";
export { ForwardRef as ReactComponent };